(function () {
	const headerMobile = () => {
		const headerSection = document.querySelector(".header-mobile-section");
		const header = document.querySelector(".header-mobile");
		let scrollPos = 0;
      //Menú invisible -----------------------------------------------------------------
      window.addEventListener("scroll", () => {
			if (!header.classList.contains("sticky-header")) {
				return;
			}
			const scroll = window.scrollY;
			if (scroll > 120) {
				header.classList.add('header-scroll');
			} else {
				header.classList.remove('header-scroll');
			}
        
           if(scroll > scrollPos){
              	showHeaderChange();
               
            }else if(scroll < 160){
                originalHeader();
               
            }
        
			scrollPos = scroll;
		});
	  //--------------------------------------------------------------------------------------
		function hideHeader() {
			if (header.classList.contains("sticky-header-always")) {
				return "";
			}
			headerSection.classList.add("hide");
		}
		function showHeader() {
           // LOGIN INVISIBLE K-UX ------
           header.classList.add("back-color-menu");
		   header.classList.add("color-background-1");
           // ---------------------------
			headerSection.classList.remove("hide");
		}

       // LOGIN INVISIBLE K-UX ------
         function originalHeader() {
         header.classList.add("back-color-menu");
		 header.classList.add("color-background-1");
		 
      }
        function showHeaderChange() {
          header.classList.remove("back-color-menu");
		  header.classList.remove("color-background-1"); 
              
		}
        // ---------------------------

		const burger = document.querySelector(".header-mobile__burger");
		const mobileMenu = document.querySelector(".header-mobile__menu");
		const mobileAnimateBg = document.querySelector(".animate-bg");
		burger.addEventListener("click", function (e) {
			e.preventDefault();
			this.classList.toggle("active");
			mobileMenu.classList.toggle("active");
			mobileAnimateBg.classList.toggle("active");
			document.body.classList.toggle("overflow-hidden");
           // LOGIN INVISIBLE K-UX ------
            setTimeout(function() {
            originalHeader();
            }, 500);
            // ---------------------------
		});

		const mobileMenuList = document.querySelectorAll(
			".header-mobile__menu-header a"
		);
		mobileMenuList.forEach((item) => {
			item.addEventListener("click", function (event) {
				event.preventDefault();
				const id = this.getAttribute("href");
				mobileMenuList.forEach((_item) => {
					_item.parentElement.classList.remove("active");
				});
				this.parentElement.classList.add("active");
				const menus = document.querySelectorAll(".header-mobile__menus > li");
				const current = document.querySelector(id);
			
				menus.forEach((_menu) => {
					_menu.style.display = "none";
				});
				current.style.display = "block";
			});
		});
	};

	document.addEventListener("shopify:section:load", headerMobile);
	headerMobile();
})();
